import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import LoadingButton from '@mui/lab/LoadingButton';
import ConfirmIcon from '@mui/icons-material/Done';

import * as Constants from "../../../../consts/Constants.js";

import { formatDateDDMMYYYYHHMM } from "../../../../plas/utils";
import { callStates } from "../../../../plas/services/calls/models";

export default function CallInfoBox({ open, close, call, apply, applying }) {
  
  return (
    <Dialog
      onClose={close}
      open={true}>
      <DialogTitle sx={{ m: 0, p: 2 }} aria-labelledby="customized-dialog-title">
        { call.name }
        <IconButton aria-label="close" onClick={close} style={{ position: 'absolute', right: "8px", top: "8px", color: (theme) => theme.palette.grey[500] }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <Typography style={{fontSize:"14px", marginBottom:"20px"}}>
          Apertura: {formatDateDDMMYYYYHHMM(call.startDate)} - Cierre: {formatDateDDMMYYYYHHMM(call.endDate)}
        </Typography>
        <Typography gutterBottom style={{whiteSpace: "pre-line"}}>
          {call.description}
        </Typography>
      </DialogContent>
      <DialogActions>
        <LoadingButton
          loading={applying}
          disabled={call.state !== 2}
          style={call.state !== 2 ? callStates.getByCode(call.state).style : {background: Constants.COLOR_PRIMARY, color: 'white' }}
          loadingPosition="start"
          startIcon={<ConfirmIcon />}
          variant="contained"
          onClick={apply}>
          Postularme
        </LoadingButton>
      </DialogActions>


    </Dialog>

  );
}
